import { render, staticRenderFns } from "./status-bar.renderer.vue?vue&type=template&id=524d2f40&scoped=true&"
import script from "./status-bar.renderer.vue?vue&type=script&lang=js&"
export * from "./status-bar.renderer.vue?vue&type=script&lang=js&"
import style0 from "./status-bar.renderer.vue?vue&type=style&index=0&id=524d2f40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d2f40",
  null
  
)

export default component.exports